import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const TransactionRuleOverview = lazy(() => import('./transaction-rule-overview'));
const TransactionRuleCreate = lazy(() => import('./transaction-rule-create/transaction-rule-create.component'));
const TransactionRuleDetail = lazy(() => import('./transaction-rule-detail.component'));
const TransactionRuleUpdate = lazy(() => import('./transaction-rule-update/transaction-rule-update.component'));
const TransactionRuleEntityLink = lazy(() => import('./transaction-rule-entity-link.component'));

export function TransactionRuleRoutes() {
    return (
        <Route path='transaction-rules'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <TransactionRuleOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <TransactionRuleCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':ruleId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <TransactionRuleDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <TransactionRuleUpdate />
                        </AsyncComponent>
                    }
                />
                <Route path=':entityType'>
                    <Route
                        path='link'
                        element={
                            <AsyncComponent>
                                <TransactionRuleEntityLink />
                            </AsyncComponent>
                        }
                    />
                    <Route
                        index
                        element={<Navigate to='../detail' />}
                    />
                </Route>
            </Route>
        </Route>
    );
}
